import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedModule} from "../shared/shared.module";
import {PrenosUcetniJednotkaDataService} from "./prenos-ucetni-jednotka-data.service";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule
  ],
  providers: [
    {provide: PrenosUcetniJednotkaDataService, useClass: PrenosUcetniJednotkaDataService, multi: false}
  ]
})
export class PrenosUcetniJednotkaDataModule { }
